import React from "react";
import { Grid } from "@mui/material";
import translations from "../../config/language";
import { pisciculture } from "../../config/services";

const language = process.env.REACT_APP_LANGUAGE;

const FarmingDetails = ({ selectedFarmer }) => {

    const farmingDetails = selectedFarmer.farming_details;
    const typeOfCrops = selectedFarmer.types_of_crops;
    const typeOfLivestock = selectedFarmer.type_of_livestock;
    const typeOfPisciculture = selectedFarmer.types_of_pisciculture;
    const farmingMethod = selectedFarmer.farming_method;
    return (
        <div className="user-profile">
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft: "20px" }}>
                    {translations[language].educationLevel}
                </Grid>
                <Grid item lg={8} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                    {farmingDetails?.education_level[0]?.name}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].farmingExperience}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                    {farmingDetails?.farming_experience} {translations[language].years}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].farmSizeInHectares}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                    {farmingDetails?.farm_size_in_hectares} {translations[language].hectares}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].typesOfCrops}</Grid>
            </Grid>

            {typeOfCrops?.map((cropType, index) => {
                return (
                    <Grid container key={index}>
                        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                            {cropType.type_of_crops}
                        </Grid>
                        <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                            {cropType.crops?.map(crop => crop.name).join(", ") || "N/A"}
                        </Grid>
                    </Grid>
                )
            })}
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].typesOfLivestock}</Grid>
            </Grid>
            {typeOfLivestock.map((livestockType, index) => {
                return (
                    <Grid container key={index}>
                        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                            {livestockType.type_of_livestock}
                        </Grid>
                        <Grid item lg={8} container className="grid-item" style={{ padding: "0px" }}>
                            {livestockType.livestock_quantity?.length > 0 ? (
                                <Grid container spacing={1} style={{ margin: 0, width: '100%' }} >
                                    {livestockType.livestock_quantity.map((liveStock, i) => {
                                        const isLastRowItem = Math.floor(i / 4) === Math.floor((livestockType.livestock_quantity.length - 1) / 4);
                                        return (
                                            <Grid
                                                item
                                                lg={3}
                                                key={i}
                                                style={{
                                                    fontWeight: 700,
                                                    padding: "10px 10px 10px 10px",
                                                    borderRight: "1px solid #D9D9D9",
                                                    borderBottom: !isLastRowItem ? "1px solid #D9D9D9" : "none"

                                                }}
                                            >
                                                {liveStock.livestock_name}: {liveStock.livestock_count}
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            ) : (
                                <Grid item style={{ fontWeight: 700, padding: "8px 16px" }}>
                                    N/A
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                );
            })}
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].typesOfPisciculture}</Grid>
            </Grid>

            {typeOfPisciculture?.types_of_pisciculture.map((piscicultureType, index) => {
                return (
                    <Grid container key={index}>
                        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                            {piscicultureType.type_of_pisciculture}
                        </Grid>
                        <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                            {piscicultureType.pisciculture?.map(pisciculture => pisciculture.name).join(", ") || "N/A"}
                        </Grid>
                    </Grid>
                )
            })}
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].farmingMethods}</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].farmingMethods}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                    {farmingMethod.farming_method?.map(method => method.name).join(", ") || "N/A"}
                </Grid>

            </Grid>

        </div>
    );
};

export default FarmingDetails;
